import logo from './logo.svg';
import './App.css';
import Businesses from './component/businesses';

function App() {
  return (
    <>
    <Businesses/>
    </>
  );
}

export default App;
